
import { Component, AfterViewInit, OnChanges, OnInit, SimpleChanges, Input, OnDestroy } from '@angular/core';
import { sub, differenceInCalendarYears, add } from 'date-fns';
import { uniq } from 'lodash';
import { SiteAnnualgradeTrendModel } from 'src/app/models/SiteDetails/SiteAnnualgradeTrendModel';
import { AnnualGrades, ANNUALGRADE_HISTORY_INTERVAL_YEARS, DOWNLOAD_DATA_DATE_FORMAT, FORMAT_DATE_LOCALE } from 'src/app/models/app-constants';
import { googleChartsTooltipHtml, formatTooltipHtml, formatTooltipHtml2 } from '../../shared/google-charts/GoogleChartsTooltipStyles';
import { Subscription, Observable } from 'rxjs';
import { SitesDetailsService } from 'src/app/services/sitedetails.service';
import { downloadData } from 'src/app/shared/DomUtils';
import { Observe } from 'src/app/shared/custom-decorators/Observe';
import { formatDate } from '@angular/common';

declare var google : any;


// const data = [
// 	{
// 		"MeasurementYear": 2018,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2016,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2019,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2015,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2017,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2021,
// 		"Grade": "Good"
// 	},
// 	{
// 		"MeasurementYear": 2022,
// 		"Grade": "Good"
// 	},
// 	{
// 		"MeasurementYear": 2011,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2013,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2014,
// 		"Grade": "Good"
// 	},
// 	{
// 		"MeasurementYear": 2020,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2010,
// 		"Grade": "Very Good"
// 	},
// 	{
// 		"MeasurementYear": 2012,
// 		"Grade": "Very Good"
// 	}
// ];



type AnnualGradeExportDataStruct = { Year : number; Grade : string };


@Component({
	selector: 'app-site-annual-grade-statistics',
	templateUrl: './site-annual-grade-statistics.component.html',
	styleUrls: ['./site-annual-grade-statistics.component.scss']
})
export class SiteAnnualGradeStatisticsComponent  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
	@Input() annualgradeTrends : SiteAnnualgradeTrendModel[];
	@Observe("annualgradeTrends") annualgradeTrends$! : Observable<SiteAnnualgradeTrendModel[]>;
	@Input() siteName : string;
	@Input() siteId : string;

	chartData : any;
	chartDataView : any;
	chartOptions : any;
	annualGradeData : any;
	
	private exportSub : Subscription;
	private dataSub : Subscription;

	constructor(private siteDetailsService : SitesDetailsService)
	{	

	}

	ngOnInit(): void {
		this.dataSub = this.annualgradeTrends$?.subscribe({
			next : (value) => {
				if(Array.isArray(value))
				{
					google?.charts?.load('current', {packages: ['corechart', 'scatter', 'line']});				
					google?.charts?.setOnLoadCallback(this.createChart);					
				}				
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}

		});
		
	}

	

	ngOnChanges(changes: SimpleChanges): void {		

	}

	ngAfterViewInit(): void {
		
	}

	ngOnDestroy(): void {
		this.exportSub && this.exportSub?.unsubscribe();
		this.dataSub && this.dataSub?.unsubscribe();		
	}

	private createChart = () => {	

		if(!google?.visualization?.DataTable || !google?.visualization?.DataView)
		{
			return;
		}		

		const thisYear = new Date();
		const minDate = sub(thisYear, {years : ANNUALGRADE_HISTORY_INTERVAL_YEARS});

		let sortedArray : any[] = [];
		
		try 
		{				
			sortedArray = this.annualgradeTrends?.filter((a) => {
				//return a.MeasurementYear >= minDate.getFullYear();
				return true;				
			}).sort(function compare(a, b) 
			{			
				return b.MeasurementYear - a.MeasurementYear;
			}) ?? [];
		}
		catch(ex : any)
		{
			console.log(`[ Exception sorting rainfall data : ${ex?.message} ]`);
		}

		try
		{
			this.annualGradeData = [["Year"],  ["Annual Grade"]];
			this.chartData = new google.visualization.DataTable();		
			
			this.chartData.addColumn('number', 'Measurement Year');
			this.chartData.addColumn('number', 'Grade');		
			this.chartData.addColumn({'type' : 'string', 'role' : 'tooltip', 'p': {'html': true}});	
			this.chartData.addColumn({'role' : 'style'});	
	
			sortedArray.forEach((a) => {	
				let code : number =  AnnualGrades.VERY_GOOD.code;	
				try
				{
					switch(a?.Grade)
					{
						case AnnualGrades.VERY_GOOD.description:
							code = AnnualGrades.VERY_GOOD.code;										
							break;
						case AnnualGrades.GOOD.description:					
							code = AnnualGrades.GOOD.code;
							break;
						case AnnualGrades.FAIR.description:					 
							code = AnnualGrades.FAIR.code;
							break;				
						case AnnualGrades.POOR.description:					
							code = AnnualGrades.POOR.code;						
							break;				
						case AnnualGrades.VERY_POOR.description:					
							code = AnnualGrades.VERY_POOR.code;	
							break;
						case AnnualGrades.NOT_AVAILABLE.description:					
							code = AnnualGrades.NOT_AVAILABLE.code;					
							break;
						default:
							code = AnnualGrades.NOT_AVAILABLE.code;
							break;
					}	
					
					this.chartData.addRow([a.MeasurementYear, 
						code, 
						formatTooltipHtml2(
							a.Grade.toString()?.toLocaleUpperCase(),
							a.MeasurementYear.toString(),
							this.getBarColour(code)
						),
						'color: {colorplaceholder}'
						//,'color: {colorplaceholder}; opacity: 0.5'
					]);
					this.annualGradeData[0].push(a.MeasurementYear);				
					this.annualGradeData[1].push(a.Grade);			
				}
				catch(ex : any)
				{
					console.log(`[ Exception parsing annual grade data : ${ex?.message} ]`);
				}
			});		
	
			this.chartDataView = new google.visualization.DataView(this.chartData);
			this.chartDataView.setColumns(
				[0, 1, 2,
					{ 
						calc: (dataTable : any, rowIndex : any) => {							
							let hexColor = this.getBarColour(
								dataTable.getValue(rowIndex, 1)
								);
							return (dataTable.getValue(rowIndex, 3) as string).replace('{colorplaceholder}',hexColor);
						},
						type: "string",
						role: "style" 
					}
				]
			);
			
			this.chartOptions = {
				interpolateNulls : true,
				tooltip: { isHtml : true, trigger : 'focus' }, 
				width: '100%', height: '100%',
				explorer: {
					keepInBounds: true,
					actions : [],
					// actions: ['dragToZoom', 'rightClickToReset'],				
					// axis: 'horizontal',				
					//maxZoomOut: 0.9,
					//maxZoomIn: 0.9					
				},
				// chartArea: {
				//   width: '95%',
				//   left: 60
				// },
				hAxis : {
					format : "",
					gridlines : {
						count : 0
					},
					direction: -1
				},
				vAxis : { 
					//ticks : Object.entries(AnnualGrades).filter(g => g[0] != 'NOT_AVAILABLE').map((kv) => ({ v : kv[1].code, f : kv[1].description })),	
					ticks : Object.entries(AnnualGrades).filter(g => !(g[0]?.toLowerCase() === 'NOT_AVAILABLE'.toLowerCase() || g[0]?.toLowerCase() === AnnualGrades.NOT_AVAILABLE.description?.toLowerCase()))
					.map((kv) => ({ 
						v : kv[1].code, f : kv[1].description, 
						style : { 
							whiteSpace : 'nowrap',					
							paddingRight : '5px',
							fontWeight : 'bold'
						} 
					})),			
					minorGridlines : { count : 0 },
					textStyle : {
						whiteSpace : 'nowrap',					
						paddingRight : '5px',
						fontWeight : 'bold'
					},
					textPosition : 'out',
					slantedText : true,
					slantedTextAngle : 0			
				},
				legend : "none",
				bar: {groupWidth: "95%"},
			}
		}		
		catch(ex : any)
		{
			console.log(`[ Exception creating annual grade chart config : ${ex?.message} ]`);
		}		

		
	}	

	private getBarColour = (annualGrade : number) => {
		if(AnnualGrades.VERY_GOOD.code === annualGrade)
		{
			return AnnualGrades.VERY_GOOD.colour; 
		}
		else if(AnnualGrades.GOOD.code === annualGrade)
		{
			return AnnualGrades.GOOD.colour
		}
		else if(AnnualGrades.POOR.code === annualGrade)
		{
			return AnnualGrades.POOR.colour
		}
		else if(AnnualGrades.VERY_POOR.code === annualGrade)
		{
			return AnnualGrades.VERY_POOR.colour
		}
		else 
		{
			return AnnualGrades.NOT_AVAILABLE.colour
		}
	}

	public onExportDataClicked = () => {
		if(!this.siteId)
		{
			return;
		}		

		let dataResponse = "";
		this.exportSub = this.siteDetailsService?.getSiteAnnualgradeTrend(this.siteId, true)?.subscribe({
			next : (response : any) => {
				if(response)
				{
					dataResponse = response;
					if(!this.isErrorResponse(dataResponse))
					{
						downloadData(dataResponse, `Annual-Grade-${new Date().getTime()?.toString()}`, "text/csv");					
					}					
				}
			}, 
			error : (ex : Error) => {
				dataResponse = "";
			},
			complete : () => {
								
			}
		});		
	}

	private isErrorResponse = (response : any) => {
		try
		{
			const jsonResp = JSON.parse(response);
			if(jsonResp?.message)
			{
				alert(jsonResp?.message);												
				return true;
			}

		}
		catch(ex:any)
		{											
		}			
		return false;
	}

	private formatDownloadData = (inputData : string) => {
		let data = inputData ?? "";
        if(!inputData)
        {
            return data;
        }

		try
		{
			const linesOfText = inputData?.toString()?.trim().split(/\r?\n/);
			if(Array.isArray(linesOfText) && 1 < linesOfText.length)
			{			
				let parts = linesOfText[0].split(",");
				const yearIdx = parts.findIndex((a: string) => a?.toString()?.trim()?.toLocaleLowerCase() === "MeasurementYear".toLocaleLowerCase());
				const gradeIdx = parts.findIndex((a: string) => a?.toString()?.trim()?.toLocaleLowerCase() === "Grade".toLocaleLowerCase());
				if(-1 < yearIdx && -1 < gradeIdx)
				{
					try
					{
						const adt : AnnualGradeExportDataStruct [] = [];
						for(let i = 1; i < linesOfText.length; ++i)
						{
							if(linesOfText[i]?.toString()?.trim())
							{
								parts = linesOfText[i].split(",");
								if(/^\d+$/i.test(parts[yearIdx]?.toString()))
								{
									adt.push({ 
										Year : parseInt(parts[yearIdx]?.toString()),
										Grade : parts[gradeIdx]?.toString()
									});				
								}								
							}							
						}
			
						const exportData = adt.sort((a : AnnualGradeExportDataStruct, b : AnnualGradeExportDataStruct) => {
							return b.Year - a.Year;
						});
						const newLinesOfText = [];
						newLinesOfText.push("Year,Annual Grade");
			
						for(let i = 0; i < exportData.length; ++i)
						{
							newLinesOfText.push(`${exportData[i].Year},${exportData[i].Grade}`);				
						}
			
						data = newLinesOfText.join("\r\n");	
					}
					catch(ex)
					{
						data = inputData;
					}
				}					
			}
		}
		catch(ex : any)
		{
			alert(ex?.message);
		}
		
		
		return data;
	}

}

